import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Newsletter API
export const subscribeNewsletter = async (email, language = 'en') => {
  try {
    const response = await axios.post(`${API}/newsletter/subscribe`, { email, language });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Contact Form API
export const submitContactForm = async (formData) => {
  try {
    const response = await axios.post(`${API}/contact/submit`, formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Subscription API
export const createSubscription = async (subscriptionData) => {
  try {
    const response = await axios.post(`${API}/subscription/create`, subscriptionData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Health check
export const checkApiHealth = async () => {
  try {
    const response = await axios.get(`${API}/`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
